import { Application } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import { AccordionController } from '@inked/accordion';
import { AddressController } from '@inked/address';
import { AriaController } from '@inked/aria';
import { AutoSubmitController } from '@inked/auto-submit';
import { CharacterCounterController } from '@inked/character-counter';
import { ClearableController } from '@inked/clearable';
import { CloudflareTurnstileController } from '@inked/cloudflare-turnstile';
import { ConsentController } from '@inked/consent';
import { CountdownController } from '@inked/countdown';
import { CounterController } from '@inked/counter';
import { DataLayerController } from '@inked/data-layer';
import { DialogController } from '@inked/dialog';
import { DisplayController } from '@inked/display';
import { DisplayWhenCheckedController } from '@inked/display-when-checked';
import { DropdownMenuController } from '@inked/dropdown-menu';
import { DropzoneController } from '@inked/dropzone';
import { EmptyController } from '@inked/empty';
import { EventController } from '@inked/event';
import { FaqController } from '@inked/faq';
import { FieldController } from '@inked/field';
import { FileUploadController } from '@inked/file-upload';
import { FocusStealController } from '@inked/focus-steal';
import { FormController } from '@inked/form';
import { FormLockController } from '@inked/form-lock';
import { FormToHistoryState } from '@inked/form-to-history-state';
import { MediaSwapController } from '@inked/media-swap';
import { ParamsController } from '@inked/params';
import { PopoverController } from '@inked/popover';
import { ProductVariantsFormController } from '@inked/product-variants-form';
import { SetController } from '@inked/set';
import { ScrollViewController } from '@inked/scroll-view';
import { SlideshowController } from '@inked/slideshow';
import { TextareaController } from '@inked/textarea';
import { TimeZoneController } from '@inked/time-zone';
import { TriggerController } from '@inked/trigger';
import { VerifyAddressController } from '@inked/verify-address';
import { VideoController } from '@inked/video';
import { WebVitalsController } from '@inked/web-vitals';
import TurboPower from 'turbo_power';

Turbo.session.drive = false;
TurboPower.initialize(Turbo.StreamActions);

const app = Application.start();

app.debug = process.env.NODE_ENV !== 'production';

app.register('accordion', AccordionController);
app.register('address', AddressController);
app.register('aria', AriaController);
app.register('auto-submit', AutoSubmitController);
app.register('character-counter', CharacterCounterController);
app.register('clearable', ClearableController);
app.register('cloudflare-turnstile', CloudflareTurnstileController);
app.register('consent', ConsentController);
app.register('countdown', CountdownController);
app.register('counter', CounterController);
app.register('data-layer', DataLayerController);
app.register('dialog', DialogController);
app.register('display', DisplayController);
app.register('display-when-checked', DisplayWhenCheckedController);
app.register('dropdown-menu', DropdownMenuController);
app.register('dropzone', DropzoneController);
app.register('empty', EmptyController);
app.register('event', EventController);
app.register('faq', FaqController);
app.register('field', FieldController);
app.register('file-upload', FileUploadController);
app.register('focus-steal', FocusStealController);
app.register('form', FormController);
app.register('form-lock', FormLockController);
app.register('form-to-history-state', FormToHistoryState);
app.register('media-swap', MediaSwapController);
app.register('params', ParamsController);
app.register('popover', PopoverController);
app.register('product-variants-form', ProductVariantsFormController);
app.register('set', SetController);
app.register('scroll-view', ScrollViewController);
app.register('slideshow', SlideshowController);
app.register('textarea', TextareaController);
app.register('time-zone', TimeZoneController);
app.register('trigger', TriggerController);
app.register('verify-address', VerifyAddressController);
app.register('video', VideoController);
app.register('web-vitals', WebVitalsController);

export {
  app as Application,
  Turbo,
  TurboPower,
};
